import axios from 'axios';
import { IGeneralExpenseModel } from './GeneralExpenseModel';

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const GENERAL_EXPENSE_CREATE_URL = `${API_URL}api/v1/customer/general/create`;
export const GENERAL_EXPENSE_GET_ALL_URL = `${API_URL}api/v1/customer/general/all`;
export const GENERAL_EXPENSE_DELETE_URL = `${API_URL}api/v1/customer/general/delete/`;
export const GENERAL_EXPENSE_UPDATE_URL = `${API_URL}api/v1/customer/general/update/`;

// Authorization header helper
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Create Location (id gönderilmez)
export function createGeneralExpense(generalExpenseData: IGeneralExpenseModel) {
    const { id, ...dataWithoutId } = generalExpenseData; // id'yi göndermiyoruz
    return axios.post(GENERAL_EXPENSE_CREATE_URL, dataWithoutId, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}

// ✅ Update Location (/update/{id})
export function updateGeneralExpense(generalExpenseData: IGeneralExpenseModel) {
    return axios.post(GENERAL_EXPENSE_UPDATE_URL + generalExpenseData.id, generalExpenseData, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}



// ✅ Load all locations (pageable destekli)
export function loadGeneralExpenses(page = 0) {
    return axios
        .get(GENERAL_EXPENSE_GET_ALL_URL, {
            headers: getAuthHeaders(),
            params: { page, size: 20 },
            withCredentials: true,
        })
        .then((res) => ({
            ...res,
            data: res.data.payload?.content || res.data.payload || res.data,
        }));
}

// ✅ Delete Location (/delete/{id})
export function deleteGeneralExpense(generalExpenseId: string) {
    return axios.post(GENERAL_EXPENSE_DELETE_URL + generalExpenseId);
}

